import checkIcon from "../../images/icon/correct.png";
import spinner from "../../images/icon/loading.png";

import thumb1 from "../../images/octopuses/new/10_.jpg";
import thumb2 from "../../images/octopuses/new/20_.jpg"; 
import thumb3 from "../../images/octopuses/new/35_.jpg";
import thumb4 from "../../images/octopuses/new/50_.jpg";
import thumb5 from "../../images/octopuses/new/65_.jpg";
import thumb6 from "../../images/octopuses/new/75_.jpg";
import thumb7 from "../../images/octopuses/new/85_.jpg";
import thumb8 from "../../images/octopuses/new/100_.jpg";
import {IoCheckmarkDoneOutline} from "react-icons/io5"
import { FaCheck } from "react-icons/fa";
const data = [
  {
    progressIcon: checkIcon,
    progress: "10",
    title: "STEP Into the Market ",
    text:"The public has access to the official launch of the ALPHA OCTOPUS Discord server and sneak peeks of our collection and whitelisting can be available for all public users throughout our social media platforms.",
    thumb: thumb1,
  },
  {
    progressIcon: spinner,
    progress: "20",
    title: "Launching The Collection",
    text:"Official Pre-Sale Minting for the first 111 ALPHA OCTOPUS becomes available for whitelisted members for 0.75 ETH, and public minting will be live for 0.888 ETH",
    thumb: thumb2,
  },
  {
    progressIcon: spinner,
    progress: "35",
    title: "COMMUNITY & CONNECTION",
    text: "Community Platforms will allow an ALPHA OCTOPUS Holder to have Voting Power on all major decisions, Announce Partnerships. all holders will be rewarded with exclusive Information on Investment Opportunities",
    thumb: thumb4,
  },
  {
    progressIcon: spinner,
    progress: "50",
    title: "PURCHASE, INVESTMENT & TRADE OPPORTUNITY    ",
    text:"Official Merch Store will be Released to all Current Holders with Access to High-Quality Merch Related to ALPHA OCTOPUS BrandCOMMUNITY & CONNECTION",
    thumb: thumb3,
  },
  {
    progressIcon: spinner,
    progress: "65",
    title: "UTILITIES & BENEFITS",
    text:" Utilities Include Lifestyle Coach Management, Success Wealth Management Coaching, Concierge Service, and Shareholder Collective Utility Implementation for ALPHA OCTOPUS's community.",
    thumb: thumb5,
  },
  {
    progressIcon: spinner,
    progress: "75",
    title: "PUBLIC SERVICE    ",
    text:"ALPHA OCTOPUS will be participating in public services which include percentages of each sale, going into Charities for Climate Change, and an online Merchandise Store is Released to The Public creating Brand Awareness. Supporting various Charitable organizations while supporting Global Warming and People in Need.",
    thumb: thumb6,
  },
  {
    progressIcon: spinner,
    progress: "85",
    title: "COMMUNITY Rewyards   ",
    text:"Reward the Growing Community with Giveaways including ETH, USD, NFTs and Special Roles within the Community with Whitelisting Benefits of upcoming Projects. Annual Real Life Meet  Up, events, and online seminars for NFT Holders. Twitter weekly spaces with updates, announcements, and developments ",
    thumb: thumb7,
  },
  {
    progressIcon: spinner,
    progress: "100",
    title: "INFINATE POSSIBILITIES    ",
    text:"3D ALPHA OCTOPUS will be released after the first 888 NFTs have been sold and will be Expanding a global utility operation for all APLPHA OCTOPUS stakeholders. ALPHA OCTOPUS Evolving into Animated NFT character for gaming, metaverse implementation and  movies. THE POSSIBILITIES ARE INFINATE!!!",
    thumb: thumb8,
  },
];

export default data;
